import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import { CreateModal } from '../containers/CreateModal';

export class CreateModalTrigger extends Component {
  displayName = CreateModalTrigger.name;

  state = {
    show: false
  };

  handleClose = () => {
    this.setState({ show: false });
  };

  handleShow = () => {
    if(!this.props.disabled)
      this.setState({ show: true });
  };

  render() {
    const { triggerText, title, render, disabled } = this.props;
    return (
      <span>
        <Button bsStyle='primary' onClick={this.handleShow} disabled={disabled}>{triggerText}</Button>
        <CreateModal title={title} handleClose={this.handleClose} show={this.state.show}>
          {render({toggle: this.handleClose})}
        </CreateModal>
       </span>
    );
  }
}